const model = { t: 'Model', name: 'model' }
export default model